var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 85,
    viewBox: "0 0 75 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6377 45.1578C62.7672 58.0212 74.866 62.3017 75 62.3562C74.8977 62.6579 73.0668 68.4562 68.6258 74.4455C64.7865 79.6236 60.8022 84.7825 54.5255 84.8894C48.358 84.9942 46.3748 81.5145 39.3236 81.5145C32.2746 81.5145 30.0712 84.7827 24.2329 84.9944C18.1743 85.2061 13.5606 79.3952 9.68977 74.236C1.77987 63.683 -4.26493 44.4158 3.85171 31.4101C7.88388 24.9514 15.0897 20.8615 22.9109 20.7566C28.8603 20.6519 34.4757 24.4502 38.1128 24.4502C41.7476 24.4502 48.5715 19.8824 55.7454 20.5532C58.7486 20.6686 67.1789 21.6727 72.592 28.9847C72.1558 29.2342 62.5331 34.4037 62.6377 45.1578ZM51.0466 13.5715C54.2632 9.97853 56.4281 4.97674 55.8375 0C51.2011 0.171962 45.5946 2.85112 42.269 6.44214C39.2886 9.62216 36.6785 14.712 37.3827 19.5902C42.5506 19.9592 47.8299 17.1668 51.0466 13.5715Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider13);
export default __webpack_public_path__ + "static/media/slider-13.f84cb404f1c8d65b5a57b5b44ba9787b.svg";
export { ForwardRef as ReactComponent };